<template>
  <div class="container pull-up">
    <div class="row">
      <div class="col-md-12">
        <div class="card m-b-30">
          <div class="card-header">
            <h5 class="m-b-0">
              <i class="mdi mdi-checkbox-intermediate"></i> {{ $t('modifier.button.all') }}
            </h5>
          </div>
          <div class="card-body">
            <div class="table-responsive">
              <data-tables :data="modifiers"
                           :pagination-props="{ pageSizes: [10, 15, 30, 40, 100], pageSize: 10 }" center-align>
                <el-table-column label="S/N" type="index" ></el-table-column>
                <el-table-column show-overflow-tooltip prop="name" :label="$t('modifier.table.title.name')" ></el-table-column>
                <el-table-column prop="user.name" :label="$t('label.creator')" ></el-table-column>
                <el-table-column prop="created_at" :formatter="$shortDate" :label="$t('label.created_at')"
                                 sortable></el-table-column>
                <el-table-column label="Actions" min-width="100px">
                  <template slot-scope="scope">
                    <el-button v-can.disable="'modifier.update'" @click="showEditDialog(scope.row.id)" split-button type="primary" size="small">
                      <i class="el-icon-edit"></i> {{ $t('button.edit') }}
                    </el-button>
                    <el-button v-can.disable="'modifier.delete'" @click="modifierDelete(scope.$index, scope.row.id)" :loading="loading" split-button type="danger" size="small">
                      <i class="el-icon-delete"></i> {{ $t('button.delete') }}
                    </el-button>
                  </template>
                </el-table-column>
              </data-tables>
            </div>
          </div>
        </div>
      </div>
    </div>
    <edit-modifier :display="displayEditDialog" @close="closeEditDialog" @updated="modifierUpdate"
                   @created="newModifier" :modifier="modifier"></edit-modifier>
  </div>
</template>

<script>
import CreateModifier from './Modal/Create'

export default {
  name: 'Index',
  components: {
    'edit-modifier': CreateModifier
  },
  data () {
    return {
      loading: false,
      modifiers: [],
      modifier: {},
      displayEditDialog: false
    }
  },
  methods: {
    showEditDialog (id) {
      this.modifier = this.modifiers.find(d => d.id === id)
      this.displayEditDialog = true
    },
    closeEditDialog () {
      this.displayEditDialog = false
    },
    newModifier (data) {
      this.modifiers.splice(0, 0, data)
    },
    modifierUpdate (data) {
      this.modifiers.splice(this.modifiers.indexOf(this.modifiers.find(d => d.id === data.id)), 1, data)
    },
    async modifierDelete (index, id) {
      this.askQuestion(this.$t('modifier.confirm.delete'), async () => {
        try {
          await this.withLoading(async () => {
            await this.$modifierService.deleteModifier(id)
            const options = await this.$modifierService.getModifierOptions(id)
            if (options.length > 0) {
              for (const option of options) {
                await this.$modifierService.deleteModifierOption(option.id)
              }
            }
            this.modifiers.splice(index, 1)
            this.showSuccess(this.$t('modifier.message.deleted'))
          }, 'loading')
        } catch (error) {
          // Error is already handled by the global interceptor
          console.log('Component caught error in modifierDelete:', error)
        }
      })
    },
    showUsersDialog (id) {}
  },
  async mounted () {
    this.$emit('parent-title', this.$t('modifier.title.modifier'))
    try {
      await this.withLoading(async () => {
        this.modifiers = await this.$modifierService.getModifiers()
      }, 'loading')
    } catch (error) {
      // Error is already handled by the global interceptor
      console.log('Component caught error in getModifiers:', error)
    }
  },
  created () {
    this.$parent.$on('new-modifier', this.newModifier)
  }
}
</script>

<style scoped>

</style>
